// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetWrapper_wrapper__21coV","clickable":"WidgetWrapper_clickable__1R3R9"};